import React from 'react';
import {useGameStore} from '../../stores/gameStore';
import {getMaxHP, getMaxMP} from '@hexcrawl/shared-utils';

interface Props {
  onReturnToLobby: () => void;
}

export const GameOverOverlay: React.FC<Props> = ({onReturnToLobby}) => {
  const gameState = useGameStore((s) => s.gameState);

  if (!gameState || gameState.status !== 'ended') return null;

  const character = gameState.character;
  const maxHP = character ? getMaxHP(character) : 0;
  const maxMP = character ? getMaxMP(character) : 0;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.85)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'monospace',
    }}>
      <div style={{
        background: '#1a1a2e',
        border: '2px solid #b44',
        borderRadius: 12,
        padding: '32px 48px',
        textAlign: 'center',
        minWidth: 320,
        maxWidth: 480,
      }}>
        <h1 style={{color: '#ff6666', fontSize: 28, margin: '0 0 8px 0'}}>Game Over</h1>
        <p style={{color: '#aaa', fontSize: 14, margin: '0 0 24px 0'}}>
          Your time has run out. The quest remains unfinished.
        </p>

        <div style={{
          background: '#0e1a2a',
          border: '1px solid #334',
          borderRadius: 8,
          padding: '16px',
          marginBottom: 24,
          textAlign: 'left',
        }}>
          <div style={{color: '#7799bb', fontSize: 12, marginBottom: 8}}>Final Stats</div>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px', fontSize: 14}}>
            <span style={{color: '#aaa'}}>Days survived:</span>
            <span style={{color: '#cccccc', fontWeight: 'bold'}}>{gameState.day - 1} / {gameState.maxDays}</span>
            {character && <>
              <span style={{color: '#aaa'}}>HP:</span>
              <span style={{color: '#88ff88', fontWeight: 'bold'}}>{character.currentHP} / {maxHP}</span>
              <span style={{color: '#aaa'}}>MP:</span>
              <span style={{color: '#88ccff', fontWeight: 'bold'}}>{character.currentMP} / {maxMP}</span>
              <span style={{color: '#aaa'}}>Level:</span>
              <span style={{color: '#cccccc', fontWeight: 'bold'}}>{character.level}</span>
            </>}
            <span style={{color: '#aaa'}}>Food remaining:</span>
            <span style={{color: '#ffcc66', fontWeight: 'bold'}}>{gameState.food}</span>
            <span style={{color: '#aaa'}}>Gold remaining:</span>
            <span style={{color: '#ffd700', fontWeight: 'bold'}}>{gameState.gold}</span>
          </div>
        </div>

        <button
          onClick={onReturnToLobby}
          style={{
            background: '#b44',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            padding: '10px 28px',
            fontFamily: 'monospace',
            fontSize: 15,
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Return to Lobby
        </button>
      </div>
    </div>
  );
};
